export default "__VITE_ASSET__CthOHkPG__"